
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.666 6.886A6.693 6.693 0 0011.69 2.21 6.472 6.472 0 006.99.335a6.782 6.782 0 00-4.728 2.03A6.558 6.558 0 00.334 7.117a6.544 6.544 0 006.556 6.551h.12a6.729 6.729 0 006.656-6.783zM6.193 3.77a.807.807 0 111.615 0v3.633a.807.807 0 11-1.615 0V3.77zm.825 7.284H7a1.01 1.01 0 01-.017-2.018H7a1.01 1.01 0 01.016 2.018h.002z","fill":"#EFE7FA"}})])
          )
        }
      }
    